import { useRef, useState } from "react";
import useObjectInput from "../../../hooks/useObjectInput";
import "../index.css";

// custom hook for GOIFirstLevel
const useGOIFirstLevel = (item) => {
  // for switching the view
  const [state, setState] = useState({
    activeTab: "",
    isSaving: false,
  });

  const { activeTab, isSaving } = state;

  const resetKey = useRef(0);

  // context state
  const { saveData, createRequestData, idValuePair } = useObjectInput();

  const onStateChange = (key, value) => {
    setState({ ...state, [key]: value });
  };

  const callback = () => {
    // resetting the key so that whole component including its children load with the latest data
    resetKey.current = resetKey.current + 1;
    setState({ ...state, isSaving: false, editMode: false });
  };

  // this function will get called if there is an error while saving the data
  const errorCallback = () => {
    setState({ ...state, isSaving: false, editMode: true });
  };

  const handleSaveBtnClick = () => {
    const data = createRequestData(item);
    setState({ ...state, isSaving: true });
    saveData(data, "", callback, errorCallback);
  };

  // returns true if any of the children input has empty value
  const inputHasNull = () => {
    return item.associatedObjects.some(
      (associatedObject) =>
        associatedObject.hasOwnProperty("value") &&
        (idValuePair[associatedObject.id] === null ||
          idValuePair[associatedObject.id] === "")
    );
  };

  return {
    state,
    setState,
    activeTab,
    isSaving,
    onStateChange,
    handleSaveBtnClick,
    inputHasNull,
    resetKey,
  };
};

export default useGOIFirstLevel;
